import gql from "graphql-tag";

export default gql`
  mutation UpdateAsset(
    $id: ID!
    $name: String
    $description: String
    $category: String
    $barcode: String
    $model: String
    $siteId: ID
    $userId: ID
  ) {
    updateAsset(
      id: $id
      name: $name
      description: $description
      category: $category
      barcode: $barcode
      model: $model
      siteId: $siteId
      primaryUserId: $userId
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/UpdateAsset.ts